import { render, staticRenderFns } from "./ModalContactNotification.vue?vue&type=template&id=5bcf673f&scoped=true&"
import script from "./ModalContactNotification.vue?vue&type=script&lang=js&"
export * from "./ModalContactNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcf673f",
  null
  
)

export default component.exports